module.exports = __webpack_public_path__ + "static/media/tokocat1.16cca725.png";